import type { Router } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'

/**
 * Installs navigation guards. Routes are private by default; mark `meta.public: true` to allow
 * anonymous access. The backend remains authoritative — guards are UX only.
 */
export function registerGuards(router: Router): void {
  router.beforeEach(async (to) => {
    const auth = useAuthStore()
    if (auth.status === 'unknown') {
      await auth.fetchSession()
    }

    const isPublic = to.meta.public === true
    if (!isPublic && !auth.isAuthenticated) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }
    // UX gate for the admin area; the backend remains authoritative on every /api/admin call.
    if (to.meta.adminOnly === true && auth.user?.isSiteAdmin !== true) {
      return { name: 'home' }
    }
    return true
  })
}
